import http from "@/plugins/axios";

export  default {
    updateRedisLockControlUuid(data){
        return http.post({
            url: '/admin/quotationSync/update/redis/lock/control/uuid',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
}